// RouterComponent.jsx
import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import DynamicSidebar from "./DynamicSidebar";
import AdminSettings from "../adminsettings/AdminSettings";
import MainContent from "../main/MainContent";
import ExportDomain from "../adminsettings/ExportDomain";
import InitialLoginHandler from "../main/InitialLoginHandler";
import AuthHandler from "../../Utils/authHandler";

const RouterComponent = () => {
  const hash = window.location.hash;
  const hasLoginHash = hash.startsWith("#/");
  const hashSegments = window.location.hash.split("/");
  // const isPlaybookRoute = window.location.hash.includes("#playbook_openOid=");
  const isPlaybookRoute =
    hash.includes("#filter_includeManual=") &&
    !hash.includes("from=doctracker");
  const isDocTrackerRoute =
    hash.includes("#filter_includeManual=") && hash.includes("from=doctracker");

  const isSpecificFilterRoute = hashSegments.length === 3;
  const hideSidebar = isSpecificFilterRoute && isPlaybookRoute;

  return (
    <Router basename="/knowledge/">
      {!hideSidebar && <DynamicSidebar />}
      <div className="main-content">
        <div className="content-wrapper">
          <AuthHandler />
          <Routes>
            {hasLoginHash ? (
              // Handle only /#/ routes
              <Route path="*" element={<InitialLoginHandler />} />
            ) : (
              // Regular routes for everything else
              <>
                <Route path="/" element={<MainContent />} />
                <Route path="/admin-settings" element={<AdminSettings />} />
                <Route path="/export-domain" element={<ExportDomain />} />
                <Route
                  path="/:username/authToken/:authToken"
                  element={<InitialLoginHandler />}
                />
                <Route
                  path="/filter_includeManual*"
                  element={<MainContent />}
                />
                <Route path="*" element={<Navigate to="/" replace />} />
              </>
            )}
          </Routes>
        </div>
      </div>
    </Router>
  );
};

export default RouterComponent;
